var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolderOpen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 56 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.4062 15.5H45V11C45 8.5625 42.9375 6.5 40.5 6.5H25.5L19.5 0.5H4.5C1.96875 0.5 0 2.5625 0 5V32C0 34.5312 1.96875 36.5 4.5 36.5H40.5938C43.2188 36.5 45.6562 35.1875 46.9688 32.9375L53.3438 22.3438C55.125 19.3438 52.9688 15.5 49.4062 15.5ZM4.5 3.5H18.1875L24.1875 9.5H40.5C41.25 9.5 42 10.25 42 11V15.5H16.0312C13.4062 15.5 10.9688 16.9062 9.5625 19.1562L3 30.2188V5C3 4.25 3.65625 3.5 4.5 3.5ZM50.7188 20.8438L44.4375 31.3438C43.5938 32.6562 42.1875 33.5 40.5938 33.5H4.125L11.8125 20.75C12.6562 19.4375 14.0625 18.5 15.75 18.5H49.4062C50.625 18.5 51.375 19.8125 50.7188 20.8438Z",
    fill: "#DFE2E3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderOpen);
export default __webpack_public_path__ + "static/media/folder-open.216e88bd.svg";
export { ForwardRef as ReactComponent };